export class Entity {

    public static getEnumEntity(entity: string): EnumEntity {
        
        switch (entity ? entity.toUpperCase() : entity) { 
            case "USER": return EnumEntity.USER;
            case "CITIZEN": return EnumEntity.CITIZEN;
            case "LEGAL_ENTITY": return EnumEntity.LEGAL_ENTITY;
            case "POST": return EnumEntity.POST;
            case "PERMISSION": return EnumEntity.PERMISSION;
            case "ARTICLE": return EnumEntity.ARTICLE;
            case "WINE_APPELLATION": return EnumEntity.WINE_APPELLATION;
            case "WINE_DENOMINATION": return EnumEntity.WINE_DENOMINATION;
            case "WINE_TYPE": return EnumEntity.WINE_TYPE;
            case "WINE": return EnumEntity.WINE;
            case "GRAPE": return EnumEntity.GRAPE;
            case "BOTTLE": return EnumEntity.BOTTLE;
            case "WINE_ENTITY": return EnumEntity.WINE_ENTITY;
            case "WINE_ENTITY_DESCRIPTION": return EnumEntity.WINE_ENTITY_DESCRIPTION;
            case "EMAIL": return EnumEntity.EMAIL;
            case "PASSWORD": return EnumEntity.PASSWORD;
            default: return EnumEntity.unknown;
        }
    }

    public static toString(enumEntity: EnumEntity): string {
        return enumEntity.toString();
    }

    public static statusById(id: number): EnumEntityStatus {

        switch (id) {
            case 1: return EnumEntityStatus.under_construction;
            case 2: return EnumEntityStatus.created;
            case 3: return EnumEntityStatus.published;
            case 4: return EnumEntityStatus.refused;
            case 5: return EnumEntityStatus.suspended;
            case 6: return EnumEntityStatus.erased;
            case 7: return EnumEntityStatus.self_created;
            default: return EnumEntityStatus.unknown;
        }
    }

    public static statusIdByEnum(status: EnumEntityStatus): number {
        switch(status) {
            case EnumEntityStatus.under_construction: return 1;
            case EnumEntityStatus.created: return 2;
            case EnumEntityStatus.published: return 3;
            case EnumEntityStatus.refused: return 4;
            case EnumEntityStatus.suspended: return 5;
            case EnumEntityStatus.erased: return 6;
            case EnumEntityStatus.self_created: return 7;
            default: return -1;
        }
    }

    public static getEnumContentCategoryList(): EnumContentCategory[] {
        return [EnumContentCategory.WINE, EnumContentCategory.RESTOURANT,
            EnumContentCategory.WINERY, EnumContentCategory.WINE_PRODUCTION,
            EnumContentCategory.PRODUCER, EnumContentCategory.TERRITORIAL_UNIT];
    }

    public static getEnumContentCategoryByDescription(description: string): string {
        switch(description.toLowerCase()) {
            case "produttore di vino": return "PRODUCER";
            case "ristorante": return "RESTOURANT";
            case "zona geografica": return "TERRITORIAL_UNIT";
            case "tipo di vino": return "WINE";
            case "cantina": return "WINERY";
            case "tecniche di produzione": return "WINE_PRODUCTION";
            default: return undefined;
        }
    }
}

export enum EnumEntity {
    USER = "USER",
    CITIZEN = "CITIZEN",
    LEGAL_ENTITY = "LEGAL_ENTITY",
    POST = "POST",
    PERMISSION = "PERMISSION",
    ARTICLE = "ARTICLE",
    WINE_APPELLATION = "WINE_APPELLATION",
    WINE_DENOMINATION = "WINE_DENOMINATION",
    WINE_TYPE = "WINE_TYPE",
    WINE = "WINE",
    GRAPE = "GRAPE",
    BOTTLE = "BOTTLE",
    WINE_ENTITY = "WINE_ENTITY",
    WINE_ENTITY_DESCRIPTION = "WINE_ENTITY_DESCRIPTION",
    EMAIL = "EMAIL",
    PASSWORD = "PASSWORD",
    unknown = "unknown",
    getEnumEntity = "getEnumEntity"
}

export enum EnumEntityStatus {
    under_construction = "under_construction",
    created = "created",
    published = "published",
    refused = "refused",
    suspended = "suspended",
    erased = "erased",
    self_created = "self_created",
    unknown = "unknown"
}

export enum EnumContentCategory {
    PRODUCER = "Produttore di vino",
	RESTOURANT = "Ristorante",
	TERRITORIAL_UNIT = "Zona geografica",
	WINE = "Tipo di vino",
	WINERY = "Cantina",
	WINE_PRODUCTION = "Tecniche di produzione"
}

export enum TooltipPosition {
    ABOVE = 'above',
    BELOW = 'below',
    LEFT = 'left',
    RIGHT = 'right',
    DEFAULT = 'default'
}

export enum TooltipTheme {
    LIGHT = 'light',
    DARK = 'dark',
    DEFAULT = 'default'
}

export enum TooltipBehavior {
    HOVER = 'hover',
    DYNAMIC = 'dynamic',
    DEFAULT = 'default'
}
